import { memo } from "react";

const MarkerSprites = () => (
  <svg width={0} height={0} display="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <symbol id="pin-marker-shape">
        <path d="M84 42.5c0 6.366-2.562 13.245-6.505 20.041-3.937 6.783-9.2 13.397-14.485 19.213-5.283 5.813-10.569 10.806-14.535 14.348a186.682 186.682 0 01-4.789 4.137c-.489.408-.888.735-1.186.977a112.76 112.76 0 01-1.186-.977 186.682 186.682 0 01-4.789-4.137c-3.966-3.541-9.252-8.535-14.535-14.348-5.286-5.816-10.548-12.43-14.484-19.213C3.562 55.745 1 48.866 1 42.5 1 19.58 19.58 1 42.5 1S84 19.58 84 42.5z" />
      </symbol>

      <symbol id="circle-marker-shape">
        <circle cx="16" cy="16" r="16" />
      </symbol>
    </defs>
  </svg>
);

export default memo(MarkerSprites);
